import Work1 from "../../assets/work-1.svg";
import Work2 from "../../assets/work-2.svg";
import Work3 from "../../assets/work-3.svg";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "Vships",
        category: ["Backend", "NodeJS", "NextJS", "microfrontend"],
        url: "https://vgrouplimited.com/our-brands/v-ships",
        // repositoryUrl: "https://github.com/GregSithole/memories-project"
    },
    {
        id: 1,
        image: Work1,
        title: "Fornova Mobility",
        category: ["Backend", "NodeJS"],
        url: "https://www.fornova.com/mobility-intelligence",
        // repositoryUrl: "https://github.com/GregSithole/memories-project"
    },
    {
        id: 2,
        image: Work2,
        title: "BrixStory",
        category: ["Backend"],
        // url: "https://cryptoverse.gregsithole.com",
        url: "https://www.brixstory.com"
    },
    {
        id: 3,
        image: Work3,
        title: "AppySaude",
        category: ["Frontend", "Angular"],
        // url: "https://cryptoverse.gregsithole.com",
        url: "https://www.appysaude.co.ao"
    },
    {
        id: 4,
        image: Work2,
        title: "EPD",
        category: ["Frontend", "Backend", "Angular"],
        // url: "https://cryptoverse.gregsithole.com",
        url: "https://edufied.co/startup"
    },
    {
        id: 5,
        image: Work3,
        title: "Filpass",
        category: ["Frontend", "Backend", "Angular"],
        // url: "https://cryptoverse.gregsithole.com",
        url: "https://filpass.ph/solutions"
    },
    {
        id: 6,
        image: Work1,
        title: "Canopy",
        category: ["Frontend", "React"],
        url: "https://www.canopyco.io"
    },
    {
        id: 7,
        image: Work3,
        title: "VIKI",
        category: ["Backend"],
        url: "https://filpass.ph/solutions"
    },
    {
        id: 8,
        image: Work1,
        title: "VIP NOW",
        category: ["Backend", "NodeJS", "React"],
        url: "https://filpass.ph/solutions"
    },
    {
        id: 9,
        image: Work2,
        title: "Wellness Coach",
        category: ["Backend", "NodeJS"],
        url: "https://www.wellnesscoach.live"
    },
    {
        id: 10,
        image: Work1,
        title: "Trust Clarity",
        category: ["Frontend", "Backend", "NodeJS", "React"],
        url: "https://www.trustclarity.com"
    },
    {
        id: 11,
        image: Work2,
        title: "TPRM App",
        category: ["Frontend", "Backend", "NodeJS", "React"],
        url: "https://www.trustclarity.com"
    },
    {
        id: 12,
        image: Work3,
        title: "GoBumper",
        category: ["Frontend", "Angular", "Ionic"],
        url: "https://www.trustclarity.com"
    },
    {
        id: 13,
        image: Work2,
        title: "AskAway",
        category: ["Frontend", "Backend", "NodeJS", "Angular"],
        url: "https://askaway.io"
    },
    {
        id: 14,
        image: Work3,
        title: "PERN APP",
        category: ["Frontend", "Backend", "NodeJS", "React"],
        url: "https://askaway.io"
    },
    {
        id: 15,
        image: Work1,
        title: "Plycoco",
        category: ["Frontend", "React"],
        url: "https://www.plycoco.de"
    },
    {
        id: 16,
        image: Work3,
        title: "IRepair Shop",
        category: ["Frontend", "Backend", "NodeJS", "React"],
        url: "https://www.plycoco.de"
    },
    {
        id: 17,
        image: Work2,
        title: "Travel Advisor",
        category: ["Frontend"],
        url: "https://travel.gregsithole.com",
        repositoryUrl: "https://github.com/GregSithole/travel-advisor"
    }
];

export default Menu;
